import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-administration',
  templateUrl: './public-administration.component.html',
  styleUrls: ['./public-administration.component.scss']
})
export class PublicAdministrationComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
